import {
  CircularProgress,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@mui/material"
import {
  PrimaryButton,
  StyledCategoryButtonContainer,
  StyledCategoryFormControl,
  StyledCategorySelectorContainer,
  StyledTransactionsContainer,
} from "./styles"
import { useAppDispatch, useAppSelector } from "../../app/hooks"
import {
  CategoryAssociationDTO,
  CategoryType,
  ClearCategory,
  ClearSubCategory,
  ClearSubCategory1,
  UpdateCategoryAssociationDTO,
  getCategoryList,
  getSubCategoryList,
  getSubCategoryList1,
  selectTransactions,
  setCategory,
  submitCategoryAssociationRequest,
  submitDeleteCategoryAssociationRequest,
  submitUpdateCategoryAssociationRequest,
} from "../../slices/transactionsSlice"
import { useEffect, useState } from "react"
import AddIcon from "@mui/icons-material/Add"
import {
  CategoriseTransactionsPayloadService,
  UpdateCategoriseTransactionsPayloadService,
} from "../../utils/transactionHelpers"

type TransactionCategorySelectorProps = Readonly<{
  category: CategoryType
  fetchTransaction?: () => void
  onClose?: () => void
  updateCategory?: boolean
}>

function TransactionCategorySelector({
  category,
  fetchTransaction,
  onClose,
  updateCategory,
}: TransactionCategorySelectorProps) {
  const {
    rowSelectionModel,
    categoryList,
    subCategoryList,
    subCategoryList1,
    isCategorisationLoading,
  } = useAppSelector(selectTransactions)

  const dispatch = useAppDispatch()

  const [initialState, setInitialState] = useState<CategoryType | null>(null)

  useEffect(() => {
    if (!rowSelectionModel.length) {
      dispatch(ClearCategory())
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rowSelectionModel])

  useEffect(() => {
    dispatch(getCategoryList({}))
    setInitialState(category)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    category.category &&
      dispatch(getSubCategoryList({ level1: category.category }))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [category.category])

  useEffect(() => {
    category.subCategory &&
      dispatch(
        getSubCategoryList1({
          level1: category.category,
          level2: category.subCategory,
        }),
      )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [category.subCategory])

  const handleCategoryChange = (e: SelectChangeEvent) => {
    dispatch(
      setCategory({
        ...category,
        category: e.target.value as string,
      }),
    )
    dispatch(ClearSubCategory())
  }
  const handleSubCategoryChange = (e: SelectChangeEvent) => {
    dispatch(
      setCategory({
        ...category,
        subCategory: e.target.value as string,
      }),
    )
    dispatch(ClearSubCategory1())
  }
  const handleSubCategory1Change = (e: SelectChangeEvent) => {
    dispatch(
      setCategory({
        ...category,
        subCategory1: e.target.value as string,
      }),
    )
  }
  const handleCategorise = () => {
    const submitData: CategoryAssociationDTO =
      CategoriseTransactionsPayloadService({
        category: category,
        transactions: rowSelectionModel,
      })
    dispatch(submitCategoryAssociationRequest(submitData))
    onClose && onClose()
    fetchTransaction && fetchTransaction()
  }
  const handleUpdateCategorise = () => {
    const submitData: UpdateCategoryAssociationDTO =
      UpdateCategoriseTransactionsPayloadService({
        categories: [
          category?.category,
          category?.subCategory,
          category?.subCategory1,
        ],
        transaction: rowSelectionModel.toLocaleString(),
      })
    dispatch(submitUpdateCategoryAssociationRequest(submitData))
    fetchTransaction && fetchTransaction()
    onClose && onClose()
  }
  const handleClearCategorise = () => {
    dispatch(
      submitDeleteCategoryAssociationRequest({
        transactionId: rowSelectionModel.toLocaleString(),
      }),
    )
    fetchTransaction && fetchTransaction()
    onClose && onClose()
  }

  return (
    <StyledTransactionsContainer updateCategory={updateCategory}>
      <StyledCategorySelectorContainer updateCategory={updateCategory}>
        <StyledCategoryFormControl size="small" updateCategory={updateCategory}>
          <InputLabel id="select-opertator">Category</InputLabel>
          <Select
            labelId="select-opertator"
            id="selectOperator"
            label="Operator"
            value={category.category}
            onChange={handleCategoryChange}
            disabled={rowSelectionModel.length === 0}
          >
            {categoryList.length > 0 ? (
              categoryList.map((category) => (
                <MenuItem key={category?.id} value={category?.id}>
                  {category?.value}
                </MenuItem>
              ))
            ) : (
              <MenuItem value="" disabled>
                No options available
              </MenuItem>
            )}
          </Select>
        </StyledCategoryFormControl>
        <StyledCategoryFormControl size="small" updateCategory={updateCategory}>
          <InputLabel id="select-opertator">Sub-Cat</InputLabel>
          <Select
            labelId="select-opertator"
            id="selectOperator"
            label="Operator"
            value={category.subCategory}
            onChange={handleSubCategoryChange}
            disabled={!category.category}
          >
            {subCategoryList.length > 0 ? (
              subCategoryList.map((category) => (
                <MenuItem value={category?.id}>{category?.value}</MenuItem>
              ))
            ) : (
              <MenuItem value="" disabled>
                No options available
              </MenuItem>
            )}
          </Select>
        </StyledCategoryFormControl>
        <StyledCategoryFormControl size="small" updateCategory={updateCategory}>
          <InputLabel id="select-opertator">Sub-Cat-2</InputLabel>
          <Select
            labelId="select-opertator"
            id="selectOperator"
            label="Operator"
            value={category.subCategory1}
            onChange={handleSubCategory1Change}
            disabled={!category.subCategory}
          >
            {subCategoryList1.length > 0 ? (
              subCategoryList1.map((category) => (
                <MenuItem value={category?.id}>{category?.value}</MenuItem>
              ))
            ) : (
              <MenuItem value="" disabled>
                No options available
              </MenuItem>
            )}
          </Select>
        </StyledCategoryFormControl>
      </StyledCategorySelectorContainer>

      {updateCategory ? (
        <StyledCategoryButtonContainer>
          <PrimaryButton
            variant="contained"
            onClick={handleClearCategorise}
            disabled={!initialState?.category}
            sx={{ width: "50%" }}
          >
            {isCategorisationLoading ? (
              <CircularProgress size={26} color="primary" />
            ) : (
              "Clear All"
            )}
          </PrimaryButton>
          <PrimaryButton
            variant="contained"
            onClick={
              initialState &&
              Object.values(initialState).every((value) => value === "")
                ? handleCategorise
                : handleUpdateCategorise
            }
            disabled={
              !category.category ||
              JSON.stringify(initialState) === JSON.stringify(category)
            }
            sx={{ width: "50%" }}
          >
            {isCategorisationLoading ? (
              <CircularProgress size={26} color="primary" />
            ) : (
              "Save"
            )}
          </PrimaryButton>
        </StyledCategoryButtonContainer>
      ) : (
        <PrimaryButton
          variant="contained"
          startIcon={<AddIcon fontSize="small" />}
          onClick={handleCategorise}
          disabled={!category.category}
        >
          {isCategorisationLoading ? (
            <CircularProgress size={26} color="primary" />
          ) : (
            "Add"
          )}
        </PrimaryButton>
      )}
    </StyledTransactionsContainer>
  )
}

export default TransactionCategorySelector
